import { Component, Element, h, Host, Prop, State } from "@stencil/core";
import { getSize, getStyle } from "../../utils/utils";

@Component({
  tag: "covet-pics-crop-text",
  styleUrl: "covet-pics-crop-text.scss"
  })
export class CovetPicsCropText {
  @Element() el: HTMLCovetPicsCropTextElement;

  /**
   * text
  */
  @Prop() text: string = "";

  /**
   * class styles
  */
  @Prop() textClass: string = "";

  /**
   * class styles
  */
  @Prop() textColor: string = "#000000";
  
  /**
   * ratio (font-size / max-lines)
  */
  @Prop() ratio = [
    { size: 48, lines: 2 },
    { size: 26, lines: 5 },
    { size: 16, lines: 8 }
  ];

  @State() cropCSS: { [key: string]: string; } = {};  
  private resizeObserver: ResizeObserver;
  private elHeight: number;
  private elWidth: number;

  componentWillLoad() {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.elHeight !== getSize(this.el, "height") || this.elWidth !== getSize(this.el, "width")) {
        this.elHeight = getSize(this.el, "height");
        this.elWidth = getSize(this.el, "width");
        this.getReviewCSS();
      }
    });
    this.resizeObserver.observe(this.el);
      
    this.getReviewCSS();
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  private getReviewCSS() {
    const PT = getStyle(this.el, "padding-top");
    const PB = getStyle(this.el, "padding-bottom");

    const elHeight = getSize(this.el, "height") - PT - PB;
    
    const textEl = this.el.querySelector(".crop-text") as HTMLElement;
    if (this.text === null || textEl === null) return;

    textEl.style.fontSize = `${this.ratio[0].size}px`;
    let textElLineHeight = getStyle(textEl, "line-height");
    textEl.style.webkitLineClamp = `${Math.round(elHeight / textElLineHeight) + 2}`;

    const calculateMaxLines = () => {
      let fontSize = this.ratio[0].size;
      let maxLines = this.ratio[0].lines;
      let testMaxLines = Math.round(getSize(textEl, "height") / textElLineHeight);
      for (let i = 0; i < this.ratio.length; i++) {
        // last
        if (i === this.ratio.length - 1) {
          if (maxLines * textElLineHeight > elHeight) {
            fontSize = this.ratio[i].size;
            maxLines = Math.floor(elHeight / textElLineHeight) > 0
              ? Math.floor(elHeight / textElLineHeight)
              : 1;
          }
          textEl.removeAttribute("style");
          return { fontSize, maxLines };
        }

        if (getSize(textEl, "height") < elHeight && testMaxLines <= maxLines) {
          textEl.removeAttribute("style");
          return { fontSize, maxLines };
        }

        fontSize = this.ratio[i + 1].size;
        textEl.style.fontSize = `${this.ratio[i + 1].size}px`;
        maxLines = this.ratio[i + 1].lines;
        textElLineHeight = getStyle(textEl, "line-height");
        textEl.style.webkitLineClamp = `${Math.round(elHeight / textElLineHeight) + 2}`;
        testMaxLines = Math.round(getSize(textEl, "height") / textElLineHeight);
      }
    };

    const { fontSize, maxLines } = calculateMaxLines();

    return this.cropCSS = {
      "--covet-crop-text-max-lines": `${maxLines}`,
      "--covet-crop-text-font-size": `${fontSize}px`,
      "--covet-crop-text-color": `${this.textColor}`,
    };
  }

  render() {
    return (
      <Host style={this.cropCSS}>
        <p class={`crop-text ${this.textClass}`} innerHTML={this.text}></p>
      </Host>
    );
  }
}